import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import Grid from "@material-ui/core/Grid";
import styles from "./BusinessSettings.module.scss";
import { Redirect } from "react-router-dom";
import DealerMembershipStatusClient from "../../shared/clients/DealerMembershipStatusClient";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import { withStyles } from "@material-ui/core/styles";
import DealerSetupDialog from "./DealerSetupDialog";
import HasPermissionTo from "../../common/HasPermissionTo";
import EmpMembershipStyles from "./EmpMembership.module.scss";
import MultiToggleWidget from "../../shared/toggles/multiToggleWidget/MultiToggleWidget";
import SetupIncompleteDialog from "./SetupIncompleteDialog";
import ConfirmDialog from "../../shared/confirmDialog/ConfirmDialog";
import { ERROR_PROCESSING, displayError } from "../../errors/ErrorConstants";
import {
  OPT_IN,
  TERMS_AND_CONDITIONS,
  RESERVATION_DEPOSIT,
} from "../../common/Constants";

const StyledSettingsGearIcon = withStyles({
  root: {
    fontFamily: "FordAntennaCond, sans-serif",
    color: "#102b4e",
  },
})(SettingsOutlinedIcon);

class EmpMembership extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notOnboardedDealers: null,
      onboardedIceDealers: null,
      onboardedBevDealers: null,
      onboardedBothDealers: null,
      retailDealers: null,
      toggleDisabledDealers: null,
    };
  }

  componentDidMount() {
    this.setState(
      {
        notOnboardedDealers: this.getNotOnboardedDealers(),
        retailDealers: this.getRetailDealers(),
        toggleDisabledDealers: this.getToggleDisabledDealers(),
      },
      () =>
        this.setState({
          // Change only to ICE true when reservation deposit will be copied over
          onboardedIceDealers: this.getOnboardedDealers(true, false, false),
          onboardedBevDealers: this.getOnboardedDealers(false, true),
          onboardedBothDealers: this.getOnboardedDealers(false, false, true),
        })
    );
  }

  getToggleDisabledDealers = () => {
    let toggleDisabledDealers = [];

    if (this.props.user.toggleDisabledDealers) {
      toggleDisabledDealers = Object.values(
        this.props.user.toggleDisabledDealers
      ).flat();
    }

    return toggleDisabledDealers;
  };

  getRetailDealers = () => {
    const retailDealers = [];

    this.props.user.dealerGroup &&
      this.props.user.dealerGroup.forEach((dealer) => {
        if (dealer.dealerType === "SDLR") {
          retailDealers.push(dealer.completeDealerId);
        }
      });

    return retailDealers;
  };

  getNotOnboardedDealers = () => {
    const dealerList = this.props.user.dealersNotFullyOnboarded;

    let notOnboardedDealers = [];
    if (dealerList) {
      if (dealerList[OPT_IN]) {
        notOnboardedDealers = notOnboardedDealers.concat(dealerList[OPT_IN]);
      }
      if (dealerList[TERMS_AND_CONDITIONS]) {
        notOnboardedDealers = notOnboardedDealers.concat(
          dealerList[TERMS_AND_CONDITIONS]
        );
      }
      if (dealerList[RESERVATION_DEPOSIT]) {
        notOnboardedDealers = notOnboardedDealers.concat(
          dealerList[RESERVATION_DEPOSIT]
        );
      }
    }

    return notOnboardedDealers;
  };

  getOnboardedDealers = (ice, bev, both) => {
    let filteredDealers =
      this.props.filteredDealers && this.props.filteredDealers;
    const onboardedDealers = [];

    if (filteredDealers && both) {
      filteredDealers = filteredDealers.filter(
        (d) => d.isIceDealer && d.isBevDealer
      );
    } else if (filteredDealers && ice) {
      filteredDealers = filteredDealers.filter(
        (d) => d.isIceDealer || d.isBevDealer
      );
    } else if (filteredDealers && bev) {
      filteredDealers = filteredDealers.filter(
        (d) => !d.isIceDealer && d.isBevDealer
      );
    }

    filteredDealers &&
      filteredDealers.forEach((d) => {
        if (
          this.state.notOnboardedDealers &&
          !this.state.notOnboardedDealers.includes(d.completeDealerId) &&
          !this.state.retailDealers.includes(d.completeDealerId)
        ) {
          onboardedDealers.push({
            name: d.name,
            id: d.completeDealerId,
            dealerId: d.dealerId,
          });
        }
      });

    return onboardedDealers;
  };

  getSimilarDealers = (dealer) => {
    if (dealer.isIceDealer && dealer.isBevDealer) {
      return this.state.onboardedBothDealers;
    } else if (dealer.isBevDealer) {
      return this.state.onboardedBevDealers;
    } else if (dealer.isIceDealer) {
      return this.state.onboardedIceDealers;
    }
  };

  getNonActionableDealer = (dealer) => {
    if (
      (this.state.retailDealers &&
        this.state.retailDealers.includes(dealer.completeDealerId)) ||
      dealer.dealerType === "MDLR" ||
      dealer.dealerType === "HUB" ||
      this.props.user.dealerId === dealer.completeDealerId
    ) {
      return true;
    }
  };

  render() {
    let dealerGroup = this.props.dealerGroup;
    dealerGroup = dealerGroup.filter(
      (dealer) => dealer.hasAccessControlContainsActive
    );
    return (
      <div>
        <div id="membershipHeader" className={`${styles.membershipTitle}`}>
          {this.props.t("EmpMembership.membershipHeader")}
        </div>
        <div>
          {Object.keys(dealerGroup).length !== 0
            ? Object.keys(dealerGroup).map((commonId) => {
                return (
                  <MembershipPanel
                    key={`panelKey_${commonId}`}
                    {...this.props}
                    dealer={dealerGroup[commonId]}
                    notOnboarded={
                      this.state.notOnboardedDealers &&
                      !this.state.notOnboardedDealers.includes(
                        dealerGroup[commonId].completeDealerId
                      )
                    }
                    similiarDealers={this.getSimilarDealers(
                      dealerGroup[commonId]
                    )}
                    notActionableDealer={this.getNonActionableDealer(
                      dealerGroup[commonId]
                    )}
                    disableToggle={
                      this.state.toggleDisabledDealers &&
                      this.state.toggleDisabledDealers.includes(
                        dealerGroup[commonId].completeDealerId
                      )
                    }
                  />
                );
              })
            : null}
        </div>
      </div>
    );
  }
}

class MembershipPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDealerActive: this.props.dealer.status === "ACTIVE",
      openDialog: false,
      openDealerSetupDialog: false,
      openSetupIncompleteDialog: false,
      hasError: [],
      disabledButton: false,
    };
    this.deactivateDialogProps = {
      title: this.props.t("EmpActivation.confirmDealerDeactivationTitle"),
      bodyText: this.props.t("EmpActivation.confirmDealerDeactivationText"),
      confirm: this.props.t("EmpActivation.confirmDealerDeactivationButton"),
      cancel: this.props.t("EmpActivation.cancelDealerDeactivationButton"),
    };
    this.activateDialogProps = {
      title: this.props.t("EmpActivation.confirmDealerActivationTitle"),
      bodyText: this.props.t("EmpActivation.confirmDealerActivationText"),
      confirm: this.props.t("EmpActivation.confirmDealerActivationButton"),
      cancel: this.props.t("EmpActivation.cancelDealerActivationButton"),
    };
  }

  handleEmpMembershipChange = (dealerId, event) => {
    const buttonStatus = event.target.checked;

    if (
      (this.state.isDealerActive && buttonStatus) ||
      (!this.state.isDealerActive && !buttonStatus)
    ) {
      return;
    }
    if (buttonStatus) {
      this.setState({ openDialog: true });
    } else {
      this.setState({ openDialog: true });
      return (
        <Redirect
          to={{
            pathname: "/dashboard",
          }}
        />
      );
    }
  };

  handleClose = () => {
    this.setState({ openDialog: false });
  };

  handleConfirmation = () => {
    DealerMembershipStatusClient.toggleEmpMembership(
      this.props.user,
      this.props.dealer.completeDealerId,
      !this.state.isDealerActive
    )
      .then(() => {
        this.setState({
          isDealerActive: !this.state.isDealerActive,
          openDialog: false,
        });
      })
      .finally(() => {
        this.props.dealer.status = this.state.isDealerActive
          ? "ACTIVE"
          : "INACTIVE";
        this.props.updateDealerEmpMembership(this.props.dealer);
      });
  };

  confirmDealerSetup = (dealerToCopy, dealerToSetup) => {
    this.setState({ disabledButton: true });
    this.props.hideOrShow(true);
    const setOptIn =
      this.props.user.permissions.rolePermissions.hasOwnProperty("optInTab");
    if (dealerToCopy && dealerToSetup) {
      DealerMembershipStatusClient.setupNewDealer(
        this.props.user,
        this.props.dealer.completeDealerId,
        dealerToCopy,
        dealerToSetup,
        setOptIn
      )
        .then(() => {
          window.location.reload();
        })
        .catch(() => {
          this.setState({
            hasError: [ERROR_PROCESSING],
          });
        })
        .finally(() => {
          this.props.hideOrShow(false);
          this.setState({ disabledButton: false });
        });
    }
  };

  getDealerSetupDialogProps = () => {
    return {
      title: this.props.t("EmpMembership.dealerSetupDialogTitle"),
      body: this.props.t("EmpMembership.dealerSetupDialogBody"),
      dropDownTitle: this.props.t(
        "EmpMembership.dealerSetupDialogDropDownTitle"
      ),
      confirm: this.props.t("EmpMembership.dealerSetupDialogConfirmButton"),
    };
  };

  getSetupIncompleteDialogProps = () => {
    return {
      title: this.props.t("EmpMembership.setupIncompleteDialogTitle"),
      body: this.props.t("EmpMembership.setupIncompleteDialogBody"),
      close: this.props.t("EmpMembership.setupIncompleteDialogCloseButton"),
      labelList: [
        this.props.t("EmpMembership.setupIncompleteDialogTnCPa"),
        this.props.t("EmpMembership.setupIncompleteDialogStoreIdPa"),
        this.props.t("EmpMembership.setupIncompleteDialogCustContPa"),
      ],
    };
  };

  toggleSetupIncompleteDialog = () => {
    this.setState((prevState) => ({
      openSetupIncompleteDialog: !prevState.openSetupIncompleteDialog,
    }));
  };

  toggleDealerSetupDialog = () => {
    this.setState((prevState) => ({
      openDealerSetupDialog: !prevState.openDealerSetupDialog,
    }));
  };

  render() {
    const pendingActionNamesList = [];

    if (displayError(this.state.hasError))
      throw new Error(this.state.hasError[0]);

    return (
      <Grid container className={styles.activationPanel}>
        <Grid item md={9}>
          <div className={`${styles.dealerName}`}>
            {`${this.props.dealer.regionalId}`} | {`${this.props.dealer.name}`}
          </div>
          {/*Dialog that allows to select Active dealer for copying the settings*/}
          <DealerSetupDialog
            {...this.props}
            dialogProps={this.getDealerSetupDialogProps()}
            open={this.state.openDealerSetupDialog}
            onClose={this.toggleDealerSetupDialog}
            handleDealerSetupDialogConfirm={this.confirmDealerSetup}
            similarDealers={this.props.similiarDealers}
            disabledButton={this.state.disabledButton}
          />
          {/*Dialog to show Dealer's list of Pending Actions*/}
          <SetupIncompleteDialog
            {...this.props}
            dialogProps={this.getSetupIncompleteDialogProps()}
            open={this.state.openSetupIncompleteDialog}
            onClose={this.toggleSetupIncompleteDialog}
            pendingActionNamesList={pendingActionNamesList}
          />
          <ConfirmDialog
            open={this.state.openDialog}
            dialogProps={
              this.state.isDealerActive
                ? this.deactivateDialogProps
                : this.activateDialogProps
            }
            onConfirm={this.handleConfirmation}
            onCancel={this.handleClose}
            onClose={this.handleClose}
            boldTitle={false}
            {...this.props}
          />
        </Grid>
        <Grid item md={3}>
          <HasPermissionTo
            perform={["empMembership:write"]}
            permissions={this.props.user.permissions.rolePermissions}
            render={() =>
              this.props.notOnboarded ? (
                !this.props.disableToggle ? (
                  <MultiToggleWidget
                    {...this.props}
                    isToggleDisabled={this.props.isMainViewingSDLR(
                      this.props.dealer
                    )}
                    toggleName={`empMembership_${this.props.dealer.regionalId}`}
                    settings={{
                      acceptedText: this.props.t("EmpMembership.active"),
                      rejectedText: this.props.t("EmpMembership.inactive"),
                      suppClass: `${styles.toggleWrapperMain}`,
                      toggleLabel: `${styles.activationToggle}`,
                    }}
                    currentStatus={this.state.isDealerActive ? "yes" : "no"}
                    onSelect={(e) =>
                      this.handleEmpMembershipChange(
                        this.props.dealer.regionalId,
                        e
                      )
                    }
                  />
                ) : (
                  ""
                )
              ) : (
                <HasPermissionTo
                  perform={["empDealerSetup"]}
                  permissions={this.props.user.permissions.rolePermissions}
                  condition={!this.props.notActionableDealer}
                  render={() => {
                    return (
                      <div
                        data-testid="setMeUpDivId"
                        id="setMeUpDivId"
                        className={
                          EmpMembershipStyles.alignElementsHorizWrapper
                        }
                        onClick={this.toggleDealerSetupDialog}
                      >
                        <StyledSettingsGearIcon
                          name={`setMeUpGearName_${this.props.dealer.regionalId}`}
                          data-testid={`setMeUpGearTestId_${this.props.dealer.regionalId}`}
                          id={`setMeUpGearTestId_${this.props.dealer.regionalId}`}
                        />{" "}
                        &nbsp;
                        <span
                          className={EmpMembershipStyles.setMeUpStyle}
                          data-testid={`setMeUpMessageTestId_${this.props.dealer.regionalId}`}
                          id={`setMeUpMessageTestId_${this.props.dealer.regionalId}`}
                        >
                          {this.props.t("EmpMembership.setMeUpGearMessage")}
                        </span>
                      </div>
                    );
                  }}
                  noRender={() => {
                    return "";
                  }}
                />
              )
            }
            noRender={() => (
              <div
                data-testid={`disabledMembershipText_${this.props.dealer.regionalId}`}
                id={`disabledMembershipText_${this.props.dealer.regionalId}`}
                className={`${styles.switches} switch-3 switch-candy`}
              >
                {this.state.isDealerActive
                  ? this.props.t("EmpMembership.active")
                  : this.props.t("EmpMembership.inactive")}
              </div>
            )}
          />
        </Grid>
      </Grid>
    );
  }
}

export default withTranslation("emp")(EmpMembership);
